import React, { useState, useMemo, useEffect, useCallback, useRef } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@mui/material/Tooltip';
import CallIcon from "@mui/icons-material/Call"; // Ícone de telefone do Material UI

import AppBar from '@mui/material/AppBar';
import SwipeableViews from 'react-swipeable-views';
import SensorsIcon from "@mui/icons-material/Sensors"; // Ícone para Zonas
import AccountTreeIcon from "@mui/icons-material/AccountTree"; // Ícone para Partições
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';

import { Stomp } from '@stomp/stompjs';

import Close from '@material-ui/icons/Close'
import { Snackbar } from '@material-ui/core';
import { Menu } from '@mui/material';
import Hls from "hls.js";

import Cookies from 'js-cookie';
import { MenuItem, Select, InputLabel, FormControl, IconButton } from '@mui/material';
import {
    FormLabel,
    RadioGroup,
    Radio,
} from '@material-ui/core';
import { Card, CardContent } from "@mui/material";

import { useHistory } from "react-router-dom";
import moment from 'moment';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, Box } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import Modal from "react-modal";
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';



import {
    MaterialReactTable
} from 'material-react-table';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import BuildIcon from '@mui/icons-material/Build';
import Switch from '@mui/material/Switch';
import SettingsIcon from '@mui/icons-material/Settings';
import PowerIcon from '@mui/icons-material/Power';
import PowerOffIcon from '@mui/icons-material/Power';



import api from '../../../../../../services/api';


import NavegadorGestao from "../../../../../../components/NavBarGestao";


import switch_off from '../../../../../../assets/imgs/switch-off.png';
import switch_on from '../../../../../../assets/imgs/switch-on.png';


import mini_icone_carro from '../../../../../../assets/imgs/mini_icone_carro.png';

import mini_icone_moto from '../../../../../../assets/imgs/mini_icone_moto.png';

import icone_origem from '../../../../../../assets/imgs/icone_origem.png';
import icone_destino from '../../../../../../assets/imgs/icone_destino.png';
import icone_parada from '../../../../../../assets/imgs/icone_parada.png';

import icone_call from '../../../../../../assets/imgs/icone_call.png';


import cabo_conectado from '../../../../../../assets/imgs/cabo_conectado.png';
import cabo_desconectado from '../../../../../../assets/imgs/cabo_desconectado.png';
import cabo_internet from '../../../../../../assets/imgs/cabo_internet.png';
import cabo_sem_internet from '../../../../../../assets/imgs/cabo_sem_internet.png';

import wifi_conectado from '../../../../../../assets/imgs/cabo_conectado.png';

import modem_conectado from '../../../../../../assets/imgs/modem_conectado.png';
import modem_desconectado from '../../../../../../assets/imgs/modem_desconectado.png';
import modem_internet from '../../../../../../assets/imgs/cabo_internet.png';
import modem_sem_internet from '../../../../../../assets/imgs/cabo_sem_internet.png';

import icone_pgm from '../../../../../../assets/imgs/icone_pgm.png';
import icone_corneta from '../../../../../../assets/imgs/corneta.png';

import icone_play from '../../../../../../assets/imgs/play.png';


import icone_medidor from '../../../../../../assets/imgs/icone_medidor.png';

import icone_subestacao from '../../../../../../assets/imgs/icone_subestacao.png';
import icone_casa from '../../../../../../assets/imgs/icone_casa.png';
import icone_loja from '../../../../../../assets/imgs/icone_loja.png';
import icone_central from '../../../../../../assets/imgs/icone_central.png';

import icone_instalacoes from '../../../../../../assets/imgs/icone_instalacoes.png';
import icone_equipamentos from '../../../../../../assets/imgs/icone_equipamentos.png';

import icone_armar_stay from '../../../../../../assets/imgs/armar_stay.png';
import icone_armar_away from '../../../../../../assets/imgs/armar_away.png';
import icone_desarmar from '../../../../../../assets/imgs/desarmar.png';
import globalConfig from '../../../../../../configs/globalConfigs';





import {
    GoogleMap,
    Marker,
    LoadScript,
    OverlayView,
    StandaloneSearchBox,
    DirectionsService,
    DirectionsRenderer,
    DistanceMatrixService,
      Circle, Polygon, Polyline
} from "@react-google-maps/api";

import "./MapPage.css";
import alarmeAudio from '../../../../../../assets/mp3/alarme.mp3';




export default function ModuloGatewayComponent({ lat, lng, tipo, onClick, status, equipamento, perimetro, id_instalacao, instalacao, flag }) {


    //const { lat, lng, tipo, onClick, status, equipamento, perimetro, id_instalacao, instalacao, flag } = props;
    const tempoInativo = 3;









    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    const [openLogTable, setOpenLogTable] = useState(false);

    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };

    const [logsPgm, setLogsPgm] = useState([]);
    const [limit, setLimit] = useState(400);










    const processarIndexAtivarRele = (index) => {
        if (index === 1) {
            //rele 1
            return 1;
        } else if (index === 2) {
            //rele 2
            return 2;
        } else if (index === 3) {
            //rele 3
            return -1;
        } else if (index === 4) {
            //rele 4
            return -1;
        }
    }

    const processarIndexDesativarRele = (index) => {
        if (index === 1) {
            //rele 1
            return 4;
        } else if (index === 2) {
            //rele 2
            return 5;
        } else if (index === 3) {
            //rele 3
            return -1;
        } else if (index === 4) {
            //rele 4
            return -2;
        }
    }

    // Calcular a diferença de tempo
    const now = new Date();
    const lastResponse = new Date(equipamento.modulo_gateway.data_hora_ultima_resposta);
    const differenceInMinutes = (now - lastResponse) / 1000 / 60; // Convertendo de milissegundos para minutos

    // Verificar se o alarme deve ser ativado
    const alarme = equipamento.alarme;

    // Definir o estado do equipamento
    const [stompClient, setStompClient] = useState(null);
    const [connected, setConnected] = useState(false);

    // Dark mode state and theme config
    const [darkMode, setDarkMode] = useState(() => {
        const saved = Cookies.get('darkMode') || Cookies.get('tema');
        return saved === 'true' || saved === 'dark';
    });

    useEffect(() => {
        const handleThemeChange = () => {
            const saved = Cookies.get('darkMode') || Cookies.get('tema');
            setDarkMode(saved === 'true' || saved === 'dark');
        };

        const intervalId = setInterval(handleThemeChange, 1000);
        window.addEventListener('storage', handleThemeChange);
        window.addEventListener('themeChange', handleThemeChange);
        window.addEventListener('darkModeChanged', handleThemeChange);
        window.addEventListener('temaChanged', handleThemeChange);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('storage', handleThemeChange);
            window.removeEventListener('themeChange', handleThemeChange);
            window.removeEventListener('darkModeChanged', handleThemeChange);
            window.removeEventListener('temaChanged', handleThemeChange);
        };
    }, []);

    const [armarStatus, setArmarStatus] = useState(equipamento.modulo_gateway.armada);

    let statusText;
    let statusColor;
    let isBlinking = false;

    const armada = equipamento.modulo_gateway.armada;

    if (alarme) {
        statusText = "ALARME";
        statusColor = "red";
        isBlinking = true; // Habilitar o piscar se estiver em alarme
    } else if (differenceInMinutes < tempoInativo) {
        if (armada) {
            statusText = "ONLINE - ARMADA";
            statusColor = "green";
        }
        else {
            statusText = "ONLINE - DESARMADA";
            statusColor = "orange";
        }
    } else {
        statusText = "OFFLINE";
        statusColor = "red";
        isBlinking = true; // Habilitar o piscar se estiver offline
    }



    const Zone = ({ zoneData }) => {

        const {
            id,
            nome,
            zoneStatus,
            armeStatus,
            zoneAlarme,
        } = zoneData;

        return (
            <Card sx={{ margin: 2, padding: 2, backgroundColor: "#f5f5f5" }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Zona {id}: {nome}
                    </Typography>
                    <Box sx={{ whiteSpace: "pre-line" }}>
                        <Typography><b>Online?</b> {zoneStatus}  </Typography>
                        <Typography><b>Armada?</b> {armeStatus}  </Typography>
                        <Typography><b>Em Alarme?</b> {zoneAlarme}</Typography>
                    </Box>
                </CardContent>
            </Card>
        );
    };



    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            align="center"
            item xs={flag === 0 ? 3 : 12}
            style={{ border: flag === 1 ? '1px solid black' : null, padding: 1, margin: flag === 1 ? 3 : 0 }}

        >
            {
                flag === 1 && (
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        align="center"
                        item xs={12}
                        style={{ padding: 1 }}
                    >
                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            align="center"
                            item xs={8}
                            style={{ padding: 0 }}
                        >
                            <span style={{ fontWeight: 'bold', fontSize: 12 }}>TITANIWM MODULO PGM</span>
                        </Grid>




                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            align="center"
                            item xs={1}
                            style={{ padding: 0 }}
                        >
                            versão <span>{equipamento.modulo_gateway.firmware_version}</span>
                        </Grid>

                    </Grid>
                )
            }
            <Grid
                container
                direction="row"
                justifyContent="center"
                align="center"
                item xs={flag === 0 ? 12 : 2}
                style={{
                    boxShadow: alarme && flag === 0 ? `0 0 30px 150px rgba(255, 0, 0, 0.5)` : "none", // Sombra afastada e translúcida
                }}>
                <Grid item xs={12}>
                    <DeviceHubIcon
                        style={{
                            fontSize: 36,
                            color: darkMode ? '#3b82f6' : '#2563eb'
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Tooltip
                        title={
                            <Typography style={{ padding: 1, fontSize: '12px' }}>
                                Última conexão: {moment(equipamento.modulo_gateway.data_hora_ultima_resposta, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY [às] HH:mm:ss")}
                            </Typography>
                        }
                        placement="top"
                        arrow
                    >
                        <span style={{ color: darkMode ? '#f8fafc' : '#0f172a', fontSize: '12px', fontWeight: '800', letterSpacing: '0.5px' }}>{equipamento.modulo_gateway.codigo} </span>
                    </Tooltip>
                </Grid>

                <Grid item xs={12}>
                    <span style={{
                        color: statusColor,
                        fontSize: '11px',
                        fontWeight: '800',
                        textTransform: 'uppercase',
                        animation: isBlinking && flag === 0 ? 'blink 2s step-start infinite' : 'none'
                    }}>
                        {statusText}
                    </span>
                </Grid>



            </Grid>
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                align="flex-start"
                item xs={flag === 0 ? 1 : 8}
            >

            </Grid>

            {flag === 1 && (
                <Grid item xs={12}
                    container
                    direction="row"
                    justifyContent="center"
                    align="center"
                    style={{ padding: 0 }}


                >


                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        align="flex-end"
                        item xs={6}
                    >
                        <Tooltip
                            title={
                                <div
                                    style={{
                                        backgroundColor: "white",
                                        minHeight: "300px",
                                        minWidth: "400px",
                                        maxHeight: "300px",
                                        maxWidth: "400px",
                                        border: "1px solid black",
                                        color: "black",
                                        overflow: "auto", // Habilita scroll quando necessário
                                    }}
                                >
                                    <Grid container direction="row" item xs={12} alignItems="center" justifyContent="flex-start">
                                        <Typography style={{ padding: 1 }}>
                                            <Box sx={{ whiteSpace: "pre-line" }}>
                                                <span>
                                                    Atualizado em{" "}
                                                    {moment(equipamento.modulo_gateway.data_hora_status_zona, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY [às] HH:mm:ss")} (
                                                    {moment(equipamento.modulo_gateway.data_hora_status_zona, "YYYY-MM-DD HH:mm:ss").fromNow()})
                                                </span>
                                                {equipamento.modulo_gateway.status_zonas && equipamento.modulo_gateway.status_zonas
                                                    .split(";")
                                                    .filter(Boolean) // Remove strings vazias do final
                                                    .map((linha) => {
                                                        const [id, nome, zoneStatus, armeStatus, zoneAlarme] = linha.split(",");
                                                        return (
                                                            <Zone
                                                                key={id}
                                                                zoneData={{
                                                                    id,
                                                                    nome,
                                                                    zoneStatus: zoneStatus,
                                                                    armeStatus: armeStatus,
                                                                    zoneAlarme: zoneAlarme,
                                                                }}
                                                            />
                                                        );
                                                    })}
                                            </Box>
                                        </Typography>
                                    </Grid>
                                </div>
                            }
                            placement="top"
                            arrow
                            style={{ backgroundColor: 'white' }}
                            sx={{ backgroundColor: 'white' }}
                        >
                            <SensorsIcon style={{ fontSize: "30px" }} /> Zonas
                        </Tooltip>
                    </Grid>


                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        align="flex-start"
                        item xs={5}
                    >
                        <Tooltip
                            title={
                                <div
                                    style={{ backgroundColor: 'white', minHeight: '300px', minWidth: '400px', border: '1px solid black', color: 'black' }}
                                >

                                    <Grid
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="flex-start"
                                    >
                                        <Typography style={{ padding: 1 }}>
                                            <Box sx={{ whiteSpace: 'pre-line' }}>
                                                <span>
                                                    Atualizado em{" "}
                                                    {moment(equipamento.modulo_gateway.data_hora_status_particao, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY [às] HH:mm:ss")} (
                                                    {moment(equipamento.modulo_gateway.data_hora_status_particao, "YYYY-MM-DD HH:mm:ss").fromNow()})
                                                </span>
                                                <span>
                                                    {equipamento.modulo_gateway.status_central}
                                                </span>

                                            </Box>
                                        </Typography>
                                    </Grid>
                                </div>
                            }
                            placement="top"
                            arrow
                            style={{ backgroundColor: 'white' }}
                            sx={{ backgroundColor: 'white' }}
                        >
                            <AccountTreeIcon style={{ fontSize: "30px" }} /> Partições
                        </Tooltip>
                    </Grid>
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        align="flex-end"
                        item xs={1}
                    >
                    </Grid>


                </Grid>
            )}


            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                message={snackbarMessage}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                ContentProps={{
                    'aria-describedby': 'message-id',
                    style: {
                        backgroundColor: snackbarSeverity === 'success' ? '#4caf50' : '#f44336',
                        marginTop: '60px', // Ajuste a altura conforme necessário
                        fontSize: '16px',
                        fontWeight: 'bold',
                        border: '1px solid black',
                        borderRadius: '4px',
                        padding: '10px',
                        zIndex: 555,
                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',

                    }
                }}
            />


            {/* Modal */}
            {openLogTable && (
                <div
                    style={{
                        position: "fixed",
                        top: "0",
                        left: "0",
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)", // Fundo escuro com opacidade
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: "199999",
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            width: "80%",
                            height: "80%",
                            borderRadius: "8px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", // Sombra para destaque
                            display: "flex",
                            flexDirection: "column",
                            padding: "20px",
                            position: "relative",

                        }}
                    >
                        {/* Botão de fechar */}
                        <button
                            onClick={() => setOpenLogTable(false)}
                            style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                backgroundColor: "#FF4500",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                padding: "8px",
                                cursor: "pointer",
                                fontWeight: "bold",
                            }}
                        >
                            Fechar
                        </button>

                        {/* Conteúdo do Modal */}
                        <h6 style={{ marginTop: 0 }}>Historico de Eventos</h6>

                        {/* Espaço reservado para a tabela */}

                    </div>
                </div>
            )}

        </Grid>
    );


}

